const timetables = () => {
  const tables = [].slice.call(document.getElementsByClassName("timetable"));

  tables.forEach(t => {
    const td = [].slice.call(t.querySelectorAll("td"));

    td.forEach(cell => {
      cell.addEventListener("mouseover", e => {
        const index = e.target.cellIndex;
        const row = e.target.parentNode;
        const cells = [].slice.call(row.parentNode.querySelectorAll("td"));
        cells.forEach(c => {
          if (c.cellIndex === index) {
            c.classList.add("highlight");
          }
        });
      });

      cell.addEventListener("mouseout", e => {
        const index = e.target.cellIndex;
        const row = e.target.parentNode;

        const cells = [].slice.call(row.parentNode.querySelectorAll("td"));
        cells.forEach(c => {
          if (c.cellIndex === index) {
            c.classList.remove("highlight");
          }
        });
      });
    });
  });

  const showMore = [].slice.call(
    document.getElementsByClassName("route-update-show-more")
  );

  const openReadMoreUpdates = id => {
    const header = document.getElementById(id);

    if (header) {
      header.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

      const content = [].slice.call(
        header.getElementsByClassName("route-update-content")
      );
      content.forEach(i => {
        i.classList.add("active");
      });

      const items = [].slice.call(header.getElementsByClassName("row-item"));
      items.forEach(i => {
        i.classList.add("timetable-active");

        const showButton = i.querySelector(".route-update-show-more");

        if (i.classList.contains("timetable-active")) {
          showButton.innerText = "less...";
        } else {
          showButton.innerText = "more...";
        }
      });
    }
  };

  const toggleActive = element => {
    element.addEventListener("click", e => {
      e.preventDefault();
      const contentRow = element.closest(".row");
      const content = contentRow.getElementsByClassName("route-update-content");
      const showButton = element;

      content[0].classList.toggle("active");
      contentRow.classList.toggle("timetable-active");

      if (contentRow.classList.contains("timetable-active")) {
        showButton.innerText = "less...";
      } else {
        showButton.innerText = "more...";
      }
    });
  };

  showMore.forEach(el => {
    toggleActive(el);
  });

  const updatesForm = document.getElementById("updates-quick-select");
  if (updatesForm) {
    const updateSelect = updatesForm.getElementsByTagName("select")[0];

    updateSelect.addEventListener("change", e => {
      const id = e.target.value;
      console.info(id);
      openReadMoreUpdates(id);
    });

    /*
     * If we land on the page with a route in the URL hash
     * then smooth scroll and open the read more.
     */
    if (window.location.hash) {
      const hash = window.location.hash.substring(1);
      openReadMoreUpdates(hash);
    }
  }
};

export default timetables;
